import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const getPhotoLibrary = createAsyncThunk(
  "mealsSetup/getPhotoLibrary",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/list-meal-gallery-images");
      //   console.log("the res from getting meal gallery images is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const getExtraItems = createAsyncThunk(
  "mealsSetup/getExtraItems",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const { page = 1, search = "" } = payload;

      const res = await axiosInstance.get("/list-extra-items", {
        params: {
          page_type: "extra_list",
          page,
          search,
        },
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const isExtraItemChecked = createAsyncThunk(
  "mealsSetup/isExtraItemChecked",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/extra-item-status-update",
        payload,
      );
      // console.log("The res of isExtraItemChecked is :", res.data);
      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      } else {
        return res.data;
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const addNewExtraItem = createAsyncThunk(
  "mealsSetup/addNewExtraItem",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/add-or-update-extra-item",
        payload,
      );
      //   console.log("The res from thunk for add or update extra is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const onDeleteExtraItems = createAsyncThunk(
  "mealsSetup/onDeleteExtraItems",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/delete-extra-item", payload);
      // console.log("The res of deleting extra item is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);

export const addNewImages = createAsyncThunk(
  "mealsSetup/addNewImages",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/upload-multiple-images", payload);
      // console.log("The res of add new images :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const addOrUpdateMealDetail = createAsyncThunk(
  "mealsSetup/addOrUpdateMealDetail",
  async (payload, { rejectWithValue }) => {
    // alert("Add or update meal thunk called");
    try {
      const res = await axiosInstance.post("/add-or-update-meal", payload);
      // console.log("The res from thunk is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue({
        message:
          err.response?.data?.message ||
          err.response?.data?.error ||
          err.message ||
          "Failed to save mealrr",
      });
    }
  },
);

export const getAllMeals = createAsyncThunk(
  "mealsSetup/getAllMeals",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("meal-list");
      // console.log("the res of get all meal list is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const getMealDetailById = createAsyncThunk(
  "mealsSetup/getMealDetailById",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/get-meal-detail", payload);
      // console.log("The res of getting detail by id is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);

export const onDeleteMeal = createAsyncThunk(
  "mealsSetup/onDeleteMeal",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/delete-meal", payload);
      // console.log("The res of delete meal is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);

export const onMealStatusUpdate = createAsyncThunk(
  "mealsSetup/onMealStatusUpdate",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/meal-status-update", payload);
      // console.log("The meal status update thunk res is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message?.data || err.message);
    }
  },
);
